import BdoLogo from "./bdo-logo/BdoLogo";
import HeaderWrapper from "./header-wrapper/HeaderWrapper";
import InfoUser from "./info-user/InfoUser";
import { NavLink } from "react-router-dom";
import { Badge } from "antd";
import { useContext, useEffect } from "react";
import { GlobalContext } from "../global-context/globalContext";
import { useMsal } from "@azure/msal-react";

const Header = () => {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const { errorsQtty, setUser } = useContext(GlobalContext);

  useEffect(() => {
    setUser({
      // isAdmin: false,
      isAdmin:
        activeAccount?.idTokenClaims?.roles?.includes("AppAdmin") || false,
      token: activeAccount?.idToken || "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <HeaderWrapper className="bg-bdo-bg-04-white header-shadow z-10 px-10 h-[66px]">
      <div className="flex items-center w-full text-bdo-text-01-charcoal text-md font-proximanova">
        <NavLink to={"/"} className="cursor-pointer">
          <BdoLogo />
        </NavLink>
        <div className="flex gap-7 items-center ml-auto">
          {[
            { to: "/numbers", label: "Numbers" },
            { to: "/pool", label: "Pool" },
            { to: "/meeting-rooms", label: "Meeting Rooms" },
            {
              to: "/errors",
              label: (
                <>
                  Errors
                  <Badge count={errorsQtty} className="-mt-5"></Badge>
                </>
              ),
            },
          ].map(({ to, label }, index) => {
            return (
              <NavLink
                key={index}
                to={to}
                className={({ isActive }) =>
                  isActive
                    ? "text-bdo-primary-red p-4 cursor-pointer"
                    : "text-bdo-text-01-charcoal hover:font-bold p-4 cursor-pointer"
                }
              >
                {label}
              </NavLink>
            );
          })}
          <InfoUser />
        </div>
      </div>
    </HeaderWrapper>
  );
};

export default Header;
